var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.973,
    height: 17.973,
    viewBox: "0 0 17.973 17.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M10.633,9.123l7-7A1.164,1.164,0,0,0,15.985.477l-7,7-7-7A1.164,1.164,0,0,0,.342,2.124l7,7-7,7a1.164,1.164,0,1,0,1.647,1.647l7-7,7,7a1.164,1.164,0,0,0,1.647-1.647Zm0,0",
    transform: "translate(0 -0.136)",
    fill: "#67E1AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.27cf87db6f4d260de29c92f9155261cd.svg";
export { ForwardRef as ReactComponent };